<template lang="pug">
    v-card.page-card
        v-card-text
            v-form(v-model="formValid" ref="loginform")
                //- v-alert.mb-6(dense outlined type="error") 
                //- .alert-text.mb-6 提示狀態文字（你已成功登出、因為逾時所以系統將你自動登出...）
                Alert
                //- v-alert.text-left(v-if="alertText != ''" outlined dense  type="error") {{alertText}}
                v-text-field.page-input-field(v-model="email" solo dense outlined :rules="[rules.required, rules.email]" :placeholder="$t('Auth.__EnterEmail')" )
                v-text-field.page-input-field(v-model="password"  solo dense outlined :rules="[rules.required]" :placeholder="$t('Auth.__EnterPassword')" :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'" @click:append="passwordShow = !passwordShow" :type="passwordShow ? 'text' : 'password'" )
                v-btn.page-btn.mb-4(block rounded color="primary" @click="login") {{$t("Auth.__Login")}}
                .text.mb-10
                    router-link(:to="'/'+$i18n.locale+'/forgot-password'") {{$t('Auth.__ForgotPassword')}}
                .text-or.text-center.mb-4 
                    span {{$t('Auth.__Or')}}
                //- GoogleLogin#google-btn.google-btn.mb-4(:params="googleParams"  :onSuccess="onSuccess" :onFailure="onFailure" :onCurrentUser="onCurrentUser")
                v-btn#google-btn.google-btn.mb-4(block rounded dark color="#4285f4") 
                    v-avatar(left size="30" )
                        v-img(src="@/assets/images/icon-google.png")
                    | {{$t('Auth.__ContinueWithGoogle')}}
                .text.mb-10 
                    router-link(:to="'/'+$i18n.locale+'/signup'") {{$t('Auth.__SignUp')}}
                .text 
                    i18n(path="Auth.__Agreement")
                        a.mr-2(href="https://www.2sumup.com/blank-1" target="_blank") {{$t('Auth.__TermsOfService')}}
                        a(href="https://www.2sumup.com/blank-2" target="_blank") {{$t('Auth.__PrivacyPolicy')}}


</template>

<script>
import * as textfieldUtils from "@/utils/textfield.js"
import * as googleAuth from "@/utils/googleAuth"

export default {
  // components: {
  //     GoogleLogin
  // },
  props: ["alert"],
  data: () => ({
    formValid: true,
    passwordShow: false,
    description: "",
    rules: textfieldUtils.rules,
    email: "",
    password: ""
    // email: "yihsian0224+25@gmail.com",
    // password: "Kn123456"
  }),
  methods: {
    login() {
      this.$store.dispatch("global/closeAlert")
      this.$refs.loginform.validate()
      if (this.formValid) {
        this.$store.dispatch("global/startLoading")
        this.$store
          .dispatch("auth/login", {
            email: this.email,
            password: this.password
          })
          .then(
            function(response) {
              this.loginSuccess(response.data.accessToken)
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/showAlert", {
                type: "error",
                message: error.message
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
      }
    },
    getBiz(bizId) {
      if (bizId != null) {
        this.$store
          .dispatch("bizes/getBiz", bizId)
          .then(
            function(response) {
              this.$store.dispatch("bizes/updateBizInfo", response.data)
              this.$router.push("/" + this.$i18n.locale + "/dashboard")
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/showAlert", {
                type: "error",
                message: error.message
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
      } else {
        this.$router.push("/" + this.$i18n.locale + "/business-info")
        this.$store.dispatch("global/stopLoading")
      }
    },
    getMe() {
      // this.getBiz()
      this.$store
        .dispatch("account/me")
        .then(
          function(response) {
            var user = response.data
            this.$store.dispatch("account/updateUser", response.data)
            if (user.isEmailVerified) {
              this.getBiz(response.data.lastlyUsedBusinessId)
            } else {
              this.$router.push({
                name: "VerifyEmail",
                params: {
                  email: user.email
                }
              })
              this.$store.dispatch("global/stopLoading")
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    loginByGoogle(token) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("auth/loginByGoogle", { token })
        .then(
          function(response) {
            this.loginSuccess(response.data.accessToken)
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlert", {
              type: "error",
              message: error.message
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },

    loginSuccess(accessToken) {
      this.$store.dispatch("auth/updateToken", {
        token: accessToken
      })
      this.getMe()
    }
  },
  mounted() {
    var vm = this
    googleAuth
      .getAuth2()
      .then(auth2 => {
        auth2.attachClickHandler(
          document.getElementById("google-btn"),
          {},
          function(googleUser) {
            vm.loginByGoogle(googleUser.getAuthResponse().id_token)
          },
          function(error) {}
        )
      })
      .catch(error => {
        // this.$store.dispatch("global/showAlert", {
        //     type: "error",
        //     message: "google auth fail"
        // })
      })

    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/login.scss";
</style>
